module.exports = __webpack_public_path__ + "img/aboutus.8ea1b0dd.png";